"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpServer = exports.HttpServerGeneric = void 0;
var http = require("http");
var dispatcher_1 = require("../../dispatcher");
var logger_1 = require("../../logger");
var transport_context_1 = require("./transport.context");
var transport_context_system_1 = require("./transport.context.system");
var HttpServerGeneric = (function () {
    function HttpServerGeneric(endpoint, port, services, logger, open, dispatcher, handlers) {
        if (open === void 0) { open = true; }
        if (dispatcher === void 0) { dispatcher = undefined; }
        if (handlers === void 0) { handlers = undefined; }
        var _this = this;
        this._port = port;
        this._endpoint = endpoint;
        if (!dispatcher) {
            this._dispatcher = new dispatcher_1.Dispatcher();
        }
        else {
            this._dispatcher = dispatcher;
        }
        services.forEach(function (s) {
            _this._dispatcher.register(s);
        });
        this.requestHandler = this.requestHandler.bind(this);
        this._logger = logger;
        this._handlers = handlers;
        this._server = http.createServer(this.requestHandler);
    }
    Object.defineProperty(HttpServerGeneric.prototype, "server", {
        get: function () {
            return this._server;
        },
        enumerable: false,
        configurable: true
    });
    HttpServerGeneric.prototype.open = function () {
        var _this = this;
        if (this._open) {
            return;
        }
        this._server
            .listen(this._port, function () {
            _this._logger.logf(logger_1.LogLevel.Info, 'Server is listening on port ' + _this._port);
        })
            .on('error', function (err) {
            _this._logger.logf(logger_1.LogLevel.Error, 'Failed to start server ' + err);
        });
    };
    HttpServerGeneric.prototype.requestHandler = function (request, response) {
        var _this = this;
        var method = request.method, url = request.url, headers = request.headers;
        var respHeaders = {};
        respHeaders['Access-Control-Allow-Origin'] = '*';
        if (method === 'OPTIONS') {
            respHeaders['Access-Control-Allow-Methods'] = 'POST, GET, PUT, DELETE, OPTIONS';
            respHeaders['Access-Control-Max-Age'] = '86400';
            respHeaders['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, X-HTTP-Method-Override, Content-Type, Accept, Authorization, X-Forwarded-For';
            response.writeHead(200, respHeaders);
            response.end();
            return;
        }
        respHeaders['Content-Type'] = 'application/json';
        var context = new transport_context_1.ConnectionContext();
        context.system = new transport_context_system_1.SystemContext();
        if (this._handlers && this._handlers.onConnect) {
            if (!this._handlers.onConnect(context, request)) {
                response.writeHead(403);
                response.end();
            }
        }
        if (headers.authorization) {
            context.system.auth.updateFromValue(headers.authorization);
            if (this._handlers && this._handlers.onAuth) {
                if (!this._handlers.onAuth(context)) {
                    response.writeHead(403);
                    response.end();
                }
            }
        }
        var endpointPos = url.indexOf(this._endpoint);
        if (endpointPos < 0) {
            var msg = 'Invalid endpoint hit: ' + url + '. Expected to use ' + this._endpoint;
            this._logger.logf(logger_1.LogLevel.Error, msg);
            response.statusCode = 500;
            response.write(msg);
            response.end();
            return;
        }
        var urlEnd = url.substr(endpointPos + this._endpoint.length);
        var pieces = urlEnd.split('/');
        if (pieces.length != 3) {
            var msg = 'Invalid endpoint format. Expected to be /serviceName/serviceMethod, got ' + urlEnd;
            this._logger.logf(logger_1.LogLevel.Error, msg);
            response.statusCode = 500;
            response.write(msg);
            response.end();
            return;
        }
        var rpcService = pieces[1];
        var rpcMethod = pieces[2];
        this._logger.logf(logger_1.LogLevel.Trace, 'Incoming request:\n', url, method);
        var body = [];
        request
            .on('error', function (err) {
            _this._logger.logf(logger_1.LogLevel.Error, 'Error while serving request: ', err);
        })
            .on('data', function (chunk) {
            body.push(chunk);
        })
            .on('end', function () {
            var data = method === 'POST' ? Buffer.concat(body).toString() : null;
            _this._logger.logf(logger_1.LogLevel.Trace, data);
            response.on('error', function (err) {
                _this._logger.logf(logger_1.LogLevel.Error, 'Error while serving response: ', err);
            });
            try {
                _this._dispatcher.dispatch(null, rpcService, rpcMethod, data)
                    .then(function (res) {
                    _this._logger.logf(logger_1.LogLevel.Trace, 'Outgoing response:\n', res);
                    response.writeHead(200, respHeaders);
                    response.write(res);
                    response.end();
                })
                    .catch(function (err) {
                    _this._logger.logf(logger_1.LogLevel.Trace, 'Outgoing response:\n', 500, err);
                    response.statusCode = 500;
                    response.write(err);
                    response.end();
                });
            }
            catch (err) {
                _this._logger.logf(logger_1.LogLevel.Warning, 'Dispatching failed:\n', err);
                response.statusCode = 500;
                response.write(err);
                response.end();
            }
        });
    };
    return HttpServerGeneric;
}());
exports.HttpServerGeneric = HttpServerGeneric;
var HttpServer = (function (_super) {
    __extends(HttpServer, _super);
    function HttpServer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HttpServer;
}(HttpServerGeneric));
exports.HttpServer = HttpServer;
//# sourceMappingURL=transport.server.http.js.map